import React from 'react';
import '@microsoft/mgt';
import {Person} from '@microsoft/mgt-react';
import PersonLoadingTemplate from './PersonLoadingTemplate';
import PersonNoDataTemplate from './PersonNoDataTemplate';

function MSTeamsUser(props) {
	return (
		<section className="userdata ms-user">
			<Person personQuery={props.emailAddress} showPresence={true}>
				<PersonLoadingTemplate template="loading"></PersonLoadingTemplate>
				<PersonNoDataTemplate template="no-data" personProps={props}></PersonNoDataTemplate>
			</Person>
		</section>
	);
}

export default MSTeamsUser;
